var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgHudFinishedFlag = function SvgHudFinishedFlag(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.467,
    height: 36.383,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 33.467 36.383"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#hud-finished-flag_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#67E8F8",
    d: "M8.8 8.8a1.167 1.167 0 1 0-2.333 0v20.417a1.167 1.167 0 0 0 2.333 0z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#E9FDFF",
    d: "M7.633 9.267a1.633 1.633 0 1 0 0-3.267 1.633 1.633 0 0 0 0 3.267"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#hud-finished-flag_svg__b)",
    d: "M27.467 8.8H8.8v12.25h18.667z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#155A78",
    d: "M18.133 8.8h-4.666v4.083h4.666zM27.467 8.8H22.8v4.083h4.667z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#155A78",
    d: "M13.467 12.883H8.8v4.084h4.667zM22.8 12.883h-4.667v4.084H22.8zM18.133 16.967h-4.666v4.083h4.666zM27.467 16.967H22.8v4.083h4.667z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "hud-finished-flag_svg__b",
    x1: 16.967,
    x2: 16.967,
    y1: 8.8,
    y2: 21.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#E9FDFF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#67E8F8"
  })))));
};
export default SvgHudFinishedFlag;